const state = () => ({
  showButtons1: false,
  showButtons2: false,
  showButtons3: false
});

const mutations = {
  SET_SHOW_BUTTONS1(state, payload) {
    state.showButtons1 = payload;
  },
  SET_SHOW_BUTTONS2(state, payload) {
    state.showButtons2 = payload;
  },
  SET_SHOW_BUTTONS3(state, payload) {
    state.showButtons3 = payload;
  }
};

const actions = {
  toggleButtons1({ commit, state }) {
    commit('SET_SHOW_BUTTONS1', !state.showButtons1);
    if (state.showButtons1) {
      commit('SET_SHOW_BUTTONS2', false);
      commit('SET_SHOW_BUTTONS3', false);
    }
  },
  toggleButtons2({ commit, state }) {
    commit('SET_SHOW_BUTTONS2', !state.showButtons2);
    if (state.showButtons2) {
      commit('SET_SHOW_BUTTONS1', false);
      commit('SET_SHOW_BUTTONS3', false);
    }
  },
  toggleButtons3({ commit, state }) {
    commit('SET_SHOW_BUTTONS3', !state.showButtons3);
    if (state.showButtons3) {
      commit('SET_SHOW_BUTTONS1', false);
      commit('SET_SHOW_BUTTONS2', false);
    }
  },
  reset({ commit }) {
    commit('SET_SHOW_BUTTONS1', false);
    commit('SET_SHOW_BUTTONS2', false);
    commit('SET_SHOW_BUTTONS3', false);
  }
};

const getters = {
  showButtons1: state => state.showButtons1,
  showButtons2: state => state.showButtons2,
  showButtons3: state => state.showButtons3
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
